<template>
  <div class="cookie-bar" v-if="$store.state.cookieWarning && (!bot)" :class="{ closing: closing }">
    <div class="cookie-flex">
      <div v-html="$nippets.cookieWarning" class="brown-text">
      </div>
      <div class="cookie-close" v-on:click="animateClose"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      closing: false,
      bot: false
    }
  },
  created () {
    this.bot = this.$k.isBot()
  },
  methods: {
    async animateClose() {
      this.closing = true
      await this.$k.waitfor(500)
      this.$store.commit('setCookieWarning', false)
    }
  }
}
</script>

<style>
.cookie-bar {
  position:fixed;
  bottom:0;
  left:0;
  width:100%;
  padding:20px 45px;
  box-sizing:border-box;
  z-index:100;
  background-color:#8b6f4b;
  color:#d6d4c8;
  transition:transform 0.5s ease;
  font-size:17px;
}


.cookie-bar.closing{
  transform: translateY(100%);
}

.brown-text {
  margin-right:30px;
}

.brown-text a:link{
  text-decoration:underline;
  color:#d6d4c8;
}

.brown-text a:visited{
  text-decoration:underline;
  color:#d6d4c8;
}

.brown-text a:hover{
  text-decoration:underline;
  color:#000;
}

.cookie-flex{
  display:flex;
  justify-content: space-between;
  align-items:center;
}

.cookie-close{
  background-image:url('../../assets/img/close-light-brown.svg');
  width:32px;
  height:32px;
  min-width:20px;
  background-size:contain;
  cursor:pointer;
}

.cookie-close:hover{
  background-image:url('../../assets/img/close.svg');
}

@media screen and (max-width:1100px){
  .cookie-bar{
    padding:10px 25px;
    font-size:14px;
  }
}

@media screen and (max-width:640px) {
  .cookie-bar {
    padding:10px 10px;
  }
}
</style>